import Splide from "@splidejs/splide";

const isRuinsPage = document.querySelector('.ruins');

let splide = null; // Храним глобально для этой функции

export function activateSlider() {

  const sliderList = document.querySelector(".active .ruin__list");
  const galleryBlock = sliderList.closest('.ruins__gallery')

  const spliderWrapper = galleryBlock.querySelector('.splider__wrapper');
  const spliderList = galleryBlock.querySelector('.splide__list');
  const ruinSlider = galleryBlock.querySelector('.ruin-slider');

  if (!sliderList || !spliderWrapper || !spliderList || !ruinSlider) return;

  sliderList.addEventListener('click', (e) => {
    const selectedItem = e.target.closest('.ruin__item');

    if (selectedItem) {
      const slides = [
        selectedItem.cloneNode(true),
        ...Array.from(sliderList.querySelectorAll('.ruin__item'))
          .filter(el => el !== selectedItem)
          .map(el => el.cloneNode(true))
      ];
      initSplider(slides);
    }
  });

  spliderWrapper.addEventListener('click', closeSlider);

  function initSplider(slides) {
    // Уничтожаем старый экземпляр, если есть
    if (splide) {
      splide.destroy();
      splide = null;
    }

    // Очищаем старые слайды
    spliderList.textContent = '';

    // Добавляем новые
    slides.forEach(slide => {
      slide.classList.add('splide__slide');
      spliderList.appendChild(slide);
    });

    spliderWrapper.classList.add('is-active');

    splide = new Splide(ruinSlider, {
      type: "loop",
      heightRatio: 0.5,
      pagination: true,
      arrows: true,
      cover: true,
      perPage: 1,
    });

    splide.mount();
  }

  function closeSlider(e) {
    if (e.target === spliderWrapper) {
      if (splide) {
        splide.destroy();
        splide = null;
      }
      spliderWrapper.classList.remove('is-active');
      spliderList.textContent = '';
    }
  }

  return splide;
}

if (isRuinsPage) {
  activateSlider();
}
